import {assert} from 'assert-ts';
import {Concept} from 'types';
import type {PostInfoApiArgs, PostInfoArgs} from '../types';
import {filterIsSearchable, getFilterValuesByName} from '../functions';
import {mapToFilters} from './mapFilters';
import {mapViewMode} from './mapViewMode';

export const mapPostInfoApiArgs = ({
  type,
  filters,
  columns,
  distinctOn,
  sort,
  page,
  size,
}: PostInfoArgs): PostInfoApiArgs => {
  // Move EQUAL ean filter into a separate more performant parameter.
  const eans = getFilterValuesByName('ean', filters, 'EQUAL');
  // Move workId filter into a separate more performant parameter.
  const workIds = getFilterValuesByName('workId', filters);

  // Map to api filters and remove non-searchable filters.
  const apiFilters = mapToFilters(filters.filter(filterIsSearchable), false);

  if (
    (apiFilters?.length ?? 0) === 0 &&
    (eans?.length ?? 0) === 0 &&
    (workIds?.length ?? 0) === 0
  ) {
    assert.soft(
      false,
      'mapPostInfoApiArgs: Atleast one of filters, eans or workIds must be provided',
      {
        type,
        filters,
        columns,
        distinctOn,
        sort,
        page,
        size,
      },
    );
  }

  // Type work requires atleast one column
  if (type === Concept.work && (columns?.length ?? 0) === 0) {
    assert.soft(
      false,
      'mapPostInfoApiArgs: Type work requires atleast one column',
      {
        type,
        filters,
        columns,
        distinctOn,
        sort,
        page,
        size,
      },
    );
  }

  return {
    type: mapViewMode(type),
    filters: apiFilters,
    columns: columns, // filterColumnsByType(allColumns, type, columns)
    distinctOn,
    eans: eans ?? [],
    workIds: workIds,
    sort: type === Concept.work ? undefined : sort,
    page: page ?? 0,
    size: size ?? 20,
  };
};
